<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import storePolicy from '@store/policy';
import {
  finalCalculationCH,
  IFinalCalculation,
} from '../../../../../helpers/finalCalculationCH';
import GeoRefArgentinaRepository, { IProvince } from '@repositories/geoRefArgentina.repository';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const emit = defineEmits(['submitRFC']);

const store = storePolicy();
const refForm2 = ref<any>(null);
const provincesARG = ref<IProvince[]>([]);
const finalCalculation = ref<IFinalCalculation | null>(null);
const fieldsForm2: any = ref([
  {
    key: 'tradeName',
    title: t('landing.forms.form_client_ar.nombre_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
		max: 20,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.nombre_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    formatValue: (e: string) => e?.toUpperCase() ?? '',
  },
  {
    key: 'email',
    title: t('landing.forms.form_client_ar.email_del_cliente'),
    type: 'email',
    validations: {
      rules: {
        required: true,
        email: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.email_del_cliente'),
    value: store.data.email ?? null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'phone1',
    title: t('landing.forms.form_client_ar.telefono_del_cliente'),
    type: 'text',
    placeholder:  t('landing.forms.form_client_ar.telefono_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'companyGPSId',
    title: t('landing.forms.form_client_ar.empresa_gps'),
    selectLabel: null,
    type: 'select',
    disabled: false,
    placeholder: t('landing.forms.form_client_ar.empresa_gps'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'address',
    title: t('landing.forms.form_client_ar.direccion_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.direccion_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'postCode',
    title: t('landing.forms.form_client_ar.codigo_postal'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.codigo_postal_placeholder'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'province',
    title: t('landing.forms.form_client_ar.provincia'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.provincia'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
    listenSelect: true,
  },
  {
    key: 'city',
    title: t('landing.forms.form_client_ar.localidad'),
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_ar.localidad'),
    value: null,
    options: [],
    cols: 12,
    customClass: 'inputSelect',
  },
]);

onMounted(async () => {
	const provinces = await GeoRefArgentinaRepository.getprovinces();
	provincesARG.value = provinces;

  fieldsForm2.value = fieldsForm2.value.map((field: any) => {
	if (field.key === 'province') {
      field.options = provinces;
    }

    return field;
  });
});

const updateFieldsInArray = (
  array: any,
  updates: any,
  preservedValues: any,
) => {
  for (const update of updates) {
    const field = array.find((field: any) => field.key === update.key);
    if (field) {
      if ('value' in update) {
        field.value = update.value;
      }
      if ('options' in update) {
        field.options = update.options;
      }
      if ('disabled' in update) {
        field.disabled = update.disabled;
      }
    }
  }

  if (preservedValues) {
    for (const key in preservedValues) {
      const field = array.find((field: any) => field.key === key);
      if (field) {
        field.value = preservedValues[key];
      }
    }
  }
};

const handleGetCities = async () => {
  const { items } = await refForm2.value.getValues();
  const preservedValues = {
    tradeName: items.tradeName,
    email: items.email,
    phone1: items.phone1,
    companyGPSId: items.companyGPSId,
    address: items.address,
    province: items.province,
  };

  if (items.province.id !== 99) {
    const cities = await GeoRefArgentinaRepository.getCities(items.province.id);
    await refForm2.value.setValue({ key: 'city', value: null });
    updateFieldsInArray(
      fieldsForm2.value,
      [
        {
          key: 'city',
          type: 'select',
          options: cities,
          value: null,
          customClass: 'inputSelect',
        },
      ],
      preservedValues,
    );
  } else {
    await refForm2.value.setValue({ key: 'city', value: null });
    updateFieldsInArray(
      fieldsForm2.value,
      [
        {
          key: 'city',
          type: 'text',
          value: null,
          customClass: 'inputLanding',
        },
      ],
      preservedValues,
    );
  }

//   finalCalculation.value = await getPricing(
//     store.data.indemnificationLimit,
//     store.client.cuit,
//     items.province.nombre,
//   );
};

defineExpose({
  fieldsForm2,
  handleGetCities,
  updateFieldsInArray,
  getValues: () => refForm2.value?.getValues(),
});
</script>

<template>
  <Form ref="refForm2" :inputs="fieldsForm2" @select="handleGetCities"></Form>
</template>
